// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__jqp4N","switch_slider":"style_switch_slider__nvq2I"};